import {UserOvpJobCondition} from '../../ovp/models/user-ovp-job-condition.models';
import _ from 'lodash';

export class User {
    /** @type {string} */
    _id = '';

    /** @type {string} */
    name = '';

    /** @type {string} */
    surname = '';

    /** @type {string} */
    address = '';

    /** @type {string} */
    identityNumber = '';

    /** @type {string} */
    email = '';

    /** @type {string} */
    username = '';

    /** @type {string} */
    jobTitle = '';

    /** @type {string} */
    jobTitleId = '';

    /** @type {string} */
    workExperience = '';

    /** @type {string} */
    company = '';

    /** @type {string|null} */
    userGroup = null;

    /** @type {string} */
    createdAt = '';

    /** @type {string} */
    updatedAt = '';

    /** @type {array} */
    documentFormResult = [];

     /** @type {array} */
    ovpJobConditions = [];

    /** @type {boolean} */
    isOnLongTermLeave = false;

    /** @type {boolean} */
    requiresPasswordChange = false;
    
    /**
     * @param {Object} obj
     * @returns {User}
     */
    static fromArray(obj) {
        const clonedObj = _.cloneDeep(obj);

        if (clonedObj && clonedObj.ovpJobConditions && clonedObj.ovpJobConditions.length) {
            clonedObj.ovpJobConditions = clonedObj.ovpJobConditions.map(ovpJobCondition => UserOvpJobCondition.fromArray(ovpJobCondition));
        }

        return Object.assign(new this, clonedObj || {});
    }
}